var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('HeadComp',{attrs:{"isChose":_vm.naveChose}}),_vm._v(" "),_c('transition',{attrs:{"name":"page"}},[_c('router-view',{ref:"routerView"})],1),_vm._v(" "),_c('FootComp',{directives:[{name:"show",rawName:"v-show",value:(_vm.footerShow),expression:"footerShow"}]})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b79682a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 